var _defs, _circle, _path, _path2, _g, _g2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 474.991,
    height: 462.841,
    viewBox: "0 0 474.991 462.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.107,
    y1: 0.129,
    x2: 0.869,
    y2: 0.845,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047a0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M6,327a6,6,0,0,1-6-6V131.872a132,132,0,0,1,264,0V321a6,6,0,0,1-6,6Z",
    transform: "translate(-0.043 0.026)",
    fill: "#f7cc47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M664.783,350.367s6.338,52.817,2.809,81.692,4.224,67.606,1.4,83.1-6.338,50.706-2.107,54.932c0,0-13.38,7.746-18.31,0,0,0-10.564-64.783-13.38-87.327s-14.086-107.045-16.9-107.749,7.044,89.439,4.93,107.749-4.93,69.016-2.809,80.284c0,0-16.9,4.93-21.831-.7,0,0,1.4-56.339,0-70.424s-19.719-104.933-11.268-133.1S639.43,278.534,664.783,350.367Z",
    transform: "translate(-585.1 -314.045)",
    fill: "#506ac1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M650.812,233.129H621.937L589.19,252.144l-5.283,51.409s4.93,83.1-2.107,98.6,26.761-2.107,30.281-7.044a80.57,80.57,0,0,0,7.044-14.084s-3.522,14.084,16.9,22.535,45.071,12.676,43.663,9.86-8.452-38.735-9.86-47.185.7-49.3.7-49.3S694.122,252.144,650.812,233.129Z",
    transform: "translate(-580.84 -233.129)",
    fill: "#506ac1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M634.974,223.4c0,.7,0,13.38,2.809,16.9s-14.084,4.226-14.084,4.226l-12.449-8.585s2.59-11.838,1.886-17.472S634.974,223.4,634.974,223.4Z",
    transform: "translate(-611.25 -216.816)",
    fill: "#fdab7d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M638.879,229.7l2.809,9.156L626.9,290.975l-12,34.235L607.172,262.8l1.643-24.883L612.1,229.7l12.676,7.748Z",
    transform: "translate(-607.172 -229.703)",
    fill: "#fdfefd"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 170.5,
    cy: 170.5,
    r: 170.5,
    transform: "translate(73.991 121.841)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M42.217,135.784a.72.72,0,0,1-.487-.862q.043-.18.089-.36a14.608,14.608,0,0,1-6.343-4.862,1.352,1.352,0,0,1,.483-1.838,1.39,1.39,0,0,1,1.844.482,11.715,11.715,0,0,0,4.508,3.54,208.877,208.877,0,0,0-4.272-25.4c-3.809-2.2-7.633-4.376-11.455-6.557a1.281,1.281,0,0,1-.258-2A73.03,73.03,0,0,1,38.94,89.8a134.671,134.671,0,0,0-18.462-3.019,1.261,1.261,0,0,1-.632-2.329l25.1-15.586q-2.422-.11-4.843-.261A313.1,313.1,0,0,1,8.553,65.062a1.2,1.2,0,0,1-.284-2.171q4.553-3.07,9.106-6.134,14.41-9.739,28.858-19.425-2.876.04-5.754.042Q23.63,37.39,6.846,36.132c-.8-.057-1.534-1.179-.745-1.791l9.648-7.52,31.816-24.7q-4.013.4-8.027.808C26.576,4.227,13.621,5.59.647,6.761c-.876.081-.85-1.255,0-1.354,3.686-.43,7.366-.859,11.055-1.255Q31.146,2.079,50.591,0a.913.913,0,0,1,.64,1.548c-3.2,2.518-6.367,5.082-9.572,7.594L9.635,34.225q3.384.224,6.769.4,16.83.849,33.654.377a1.141,1.141,0,0,1,.572,2.108l-9.084,6.174L12.012,63.225q2.98.461,5.971.858a300.231,300.231,0,0,0,31.05,2.459,1.249,1.249,0,0,1,.627,2.308Q36.938,76.761,24.218,84.675a140.284,140.284,0,0,1,18.761,3.531,1.273,1.273,0,0,1,.3,2.305A71.9,71.9,0,0,0,29.5,98.673q3.413,1.964,6.828,3.924l2.027,1.16a7.874,7.874,0,0,1,1.692,1.014,4.924,4.924,0,0,1,.729,2.247l.449,1.951q.912,4.036,1.644,8.109.942,5.278,1.616,10.587c.417-1.009.842-2.013,1.26-3.022.213-.509.443-1.016.641-1.534a2.867,2.867,0,0,1,.991-1.507.833.833,0,0,1,.852,0,.906.906,0,0,1,.434.766,3.487,3.487,0,0,1-.515,1.812l-.659,1.523c-.476,1.1-.947,2.2-1.432,3.3l-1.118,2.54q.123,1.138.234,2.277a1.346,1.346,0,0,1-1.689,1.286l-.231-.063q-.131.216-.268.428l0-.006a.685.685,0,0,1-.587.342A.662.662,0,0,1,42.217,135.784ZM38.509,106.761ZM42.307,90.64ZM49.033,69.02Z",
    transform: "matrix(-0.891, 0.454, -0.454, -0.891, 214.236, 213.313)",
    fill: "#ffd5ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M51.963,87.495a67.635,67.635,0,0,0-.957-23.38A93.137,93.137,0,0,0,34,26.588,91.254,91.254,0,0,0,19.663,11.48,91.736,91.736,0,0,0,10.6,4.923l4.4.884a.757.757,0,0,0,.163.072c.582.149,1.162.265,1.743.365a30.913,30.913,0,0,0,3.132.479l0-.018a1.563,1.563,0,0,0,.412-3.047,31.248,31.248,0,0,0-4.727-1l-4.548-.886Q6.528.864,1.859.046A1.49,1.49,0,0,0,.723,2.767q1.166.541,2.312,1.121a1.414,1.414,0,0,0-.006.168,30.926,30.926,0,0,0,.792,6.476,24.741,24.741,0,0,0,1.025,3.232A4.974,4.974,0,0,0,6.29,16.192a.958.958,0,0,0,1.4-.572,5.969,5.969,0,0,0-.523-2.7c-.293-.958-.54-1.931-.79-2.9A44.932,44.932,0,0,1,5.4,5.133,77.135,77.135,0,0,1,19.671,15.254,91.737,91.737,0,0,1,43.137,47.815,91.092,91.092,0,0,1,48.965,67.15a119.534,119.534,0,0,1,1.747,20.175h0a.677.677,0,0,0,.7.632A.521.521,0,0,0,51.963,87.495Z",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 250.684, 425.095)",
    fill: "#ffd5ce"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bitmap",
    transform: "translate(211.033 61.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M6,327a6,6,0,0,1-6-6V131.872a132,132,0,0,1,264,0V321a6,6,0,0,1-6,6Z",
    transform: "translate(-0.043 0.026)",
    fill: "#f7cc47"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-501.548 -143.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M621.46,485.934c0,.7,4.226,14.084,1.4,14.79s-9.86.7-11.27,0-2.809-.7-5.634.7-28.169,2.107-29.577,0,19.719-7.044,28.169-14.79S621.46,485.934,621.46,485.934Z",
    transform: "translate(4.459 135.541)",
    fill: "#17161d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M645.058,491.3s14.084,9.156,13.38,11.974-18.3,4.921-25.353,2.814-10.562-2.809-5.634-8.45S637.31,487.781,645.058,491.3Z",
    transform: "translate(25.934 138.624)",
    fill: "#17161d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(593.421 375.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M664.783,350.367s6.338,52.817,2.809,81.692,4.224,67.606,1.4,83.1-6.338,50.706-2.107,54.932c0,0-13.38,7.746-18.31,0,0,0-10.564-64.783-13.38-87.327s-14.086-107.045-16.9-107.749,7.044,89.439,4.93,107.749-4.93,69.016-2.809,80.284c0,0-16.9,4.93-21.831-.7,0,0,1.4-56.339,0-70.424s-19.719-104.933-11.268-133.1S639.43,278.534,664.783,350.367Z",
    transform: "translate(-585.1 -314.045)",
    fill: "#506ac1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M676.722,382.015s-42.959-2.347-55.636-29.344h0s-30.281,32.162-43.663,22.3,50-52.818,50-52.818S683.06,352.438,676.722,382.015Z",
    transform: "translate(-589.291 -310.482)",
    fill: "#20367b",
    opacity: 0.35
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(587.287 258.79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M650.812,233.129H621.937L589.19,252.144l-5.283,51.409s4.93,83.1-2.107,98.6,26.761-2.107,30.281-7.044a80.57,80.57,0,0,0,7.044-14.084s-3.522,14.084,16.9,22.535,45.071,12.676,43.663,9.86-8.452-38.735-9.86-47.185.7-49.3.7-49.3S694.122,252.144,650.812,233.129Z",
    transform: "translate(-580.84 -233.129)",
    fill: "#506ac1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M580.77,304.941s14.086-2.809,19.015-4.226c0,0,71.128,31.691,83.1,23.945s-33.1-21.127-33.1-21.127L585.7,285.222Z",
    transform: "translate(-580.871 -210.221)",
    fill: "#20367b",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M669.99,266.6c-1-.063-7.044,25.739-13.381,25.9s-19.014.16-19.014.16l-2.107-3.522s-27.653-1.557-30.987-2.107c-8.45-1.4-10.564-29.93-10.564-29.93s-12.676,23.591-14.084,28.52,5.634,16.433,5.634,16.433,76.762,15.962,83.8,2.583S681.257,267.306,669.99,266.6Z",
    transform: "translate(-581.355 -222.587)",
    fill: "#20367b",
    opacity: 0.35
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(631.07 235.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M634.974,223.4c0,.7,0,13.38,2.809,16.9s-14.084,4.226-14.084,4.226l-12.449-8.585s2.59-11.838,1.886-17.472S634.974,223.4,634.974,223.4Z",
    transform: "translate(-611.25 -216.816)",
    fill: "#fdab7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 19.014,
    cy: 18.31,
    rx: 19.014,
    ry: 18.31,
    transform: "translate(-5.151 -20.177)",
    fill: "#fdab7d",
    opacity: 0.37
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 22.535,
    cy: 29.93,
    rx: 22.535,
    ry: 29.93,
    transform: "translate(622.399 188.366)",
    fill: "#fdab7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M651.965,216.533l2.119-2.809s1.4-17.607-2.107-22.537-15.5-14.747-24.649-16.2c-13.38-2.107-5.634,11.973-12.676,9.156s-15.494,5.634-12.676,14.79,4.93,19.014,4.93,19.014-.7-16.2,2.809-14.788,11.268,7.746,21.127-.7C635.889,198.127,650.55,193.292,651.965,216.533Z",
    transform: "translate(15.498 0)",
    fill: "#37344b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M635.51,206.564c-.966,3.511-.23,6.787,1.647,7.3s4.18-1.919,5.148-5.443.23-6.787-1.647-7.3S636.468,203.047,635.51,206.564Z",
    transform: "translate(30.301 11.557)",
    fill: "#fdab7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M609.072,206.564c.967,3.511.23,6.787-1.645,7.3s-4.18-1.919-5.148-5.443-.23-6.787,1.645-7.3S608.107,203.047,609.072,206.564Z",
    transform: "translate(15.688 11.557)",
    fill: "#fdab7d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(625.199 253.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M638.879,229.7l2.809,9.156L626.9,290.975l-12,34.235L607.172,262.8l1.643-24.883L612.1,229.7l12.676,7.748Z",
    transform: "translate(-607.172 -229.703)",
    fill: "#fdfefd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M621.623,235.086s5.634,7.042,4.224,7.746-2.809,2.809-4.93,2.809-4.928-3.522-4.928-3.522Z",
    transform: "translate(-603.295 -227.336)",
    fill: "#ffa21f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M622.64,242.419l.351,27.8-6.866,30.841-4.05-8.627.7-23.239Z",
    transform: "translate(-605.017 -224.111)",
    fill: "#ffa21f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M638.715,232.151s18.311,22.535,14.086,23.239-11.268,3.522-9.86,7.042,8.452,12.677-2.809,19.015-28.873,42.255-30.985,79.58C609.138,361.027,613.234,273.3,638.715,232.151Z",
    transform: "translate(18.895 25.231)",
    fill: "#6181d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M615.425,232.151s-22.456,18.434-18.511,20.1,10.142,6.043,7.953,9.14-11.166,10.358-1.68,19.149,18.259,47.81,11.642,84.6C614.834,365.142,630.645,278.1,615.425,232.151Z",
    transform: "translate(13.312 25.231)",
    fill: "#6181d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M614.586,280.356l9.593.316-4.8,13.518-9.993-.844Z",
    transform: "translate(19.002 46.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M620.621,282.6s19.194-4.368,26.877.621-.767,16.963-11.331,14.849-20.423-3.522-20.423-3.522Z",
    transform: "translate(21.796 46.637)",
    fill: "#fdab7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M652.2,237.956c-4.214-5.393-6.039-4.816-2.809-4.226,7.518,1.378,30.7,14.472,36.268,23.945,6.066,10.321,7.746,64.081-11.268,78.17-15.855,11.745-83.1-15.494-83.1-15.494l16.9-7.042s30.985,2.107,40.141,4.226S661.883,284,663.476,280.21C674.736,253.449,652.2,237.956,652.2,237.956Z",
    transform: "translate(11.043 25.764)",
    fill: "#506ac1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M625.215,234.106s-31.338,11.268-39.79,23.241S564.3,305.94,566.412,315.094s26.761,12.641,61.974-1.424L634.02,299.6s-33.219,5.472-33.8,1.4C593.524,254.53,625.215,234.106,625.215,234.106Z",
    transform: "translate(0 26.091)",
    fill: "#506ac1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M603.619,285.273s-5.562-9.533-14.793-12.992c-5.634-2.107-14.437-.351-15.141,5.283s7.4,9.328,13.561,8.538S603.619,285.273,603.619,285.273Z",
    transform: "translate(3.283 42.499)",
    fill: "#fdab7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M649.962,200.32S647.8,221.226,639.1,221.226s-11.856-3.952-20.541,0-12.96-19.165-12.96-19.165l-1.266-.6s3.16,8.694,1.58,13.436c0,0-.79,15.8,1.58,18.178s18.961,11.061,22.92,10.276,20.541-11.061,21.34-13.436-.79-15.8-.79-15.8-.79-8.694.79-13.436S649.962,200.32,649.962,200.32Z",
    transform: "translate(16.78 10.423)",
    fill: "#37344b"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "block",
    transform: "translate(13.666 231.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 229,
    height: 121,
    rx: 6,
    transform: "translate(0.325 -0.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(18.325 19.547)",
    fill: "#f7cc47"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 66,
    height: 15,
    rx: 2,
    transform: "translate(89.325 28.547)",
    fill: "#ffe4df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 6,
    height: 31,
    rx: 3,
    transform: "translate(89.325 69.547)",
    fill: "#ffe4df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 6,
    height: 36,
    rx: 3,
    transform: "translate(107.325 64.547)",
    fill: "#ffe4df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    width: 7,
    height: 40,
    rx: 3,
    transform: "translate(126.325 60.547)",
    fill: "#ffe4df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    width: 7,
    height: 33,
    rx: 3,
    transform: "translate(144.325 67.547)",
    fill: "#ffe4df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    "data-name": "Rectangle",
    width: 6,
    height: 27,
    rx: 3,
    transform: "translate(163.325 73.547)",
    fill: "#ffe4df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    "data-name": "Rectangle",
    width: 6,
    height: 31,
    rx: 3,
    transform: "translate(182.325 69.547)",
    fill: "#ffe4df"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    "data-name": "Rectangle",
    width: 7,
    height: 22,
    rx: 3,
    transform: "translate(200.325 78.547)",
    fill: "#ffe4df"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Star",
    d: "M78.8,119.064l-19,37.382.552-41.928L26.161,138.79l19.973-36.868-41.555,5.6L39.4,84.16,0,69.808,41.688,65.3,13.472,34.285,52.479,49.669,41.909,9.092,69.3,40.841,78.8,0l9.5,40.841,27.39-31.749-10.57,40.577,39.007-15.384L115.906,65.3l41.688,4.506L118.2,84.16l34.819,23.363-41.555-5.6,19.973,36.868L97.241,114.518l.552,41.928Z",
    transform: "translate(35.193 0) rotate(13)",
    fill: "#f094e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.833,34A2.775,2.775,0,0,1,0,31.167c0-2.833,2.833-11.333,17-11.333s17,8.5,17,11.333A2.775,2.775,0,0,1,31.167,34ZM8.5,8.5A8.5,8.5,0,1,1,17,17,8.5,8.5,0,0,1,8.5,8.5Z",
    transform: "translate(76.991 77.841)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinHand);
export default __webpack_public_path__ + "static/media/joinHand.ba9142915ce3c1fdbcc0a28ebd1e0634.svg";
export { ForwardRef as ReactComponent };